import { Api } from '@axiom/ui';
import type {
  Candidate,
  CandidateCommunicationAlerts,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateCommunicationAlertsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readCommunicationAlerts(candidateId: Candidate['id']) {
    return super.read<{ data: CandidateCommunicationAlerts }>({
      endpoint: `/candidates/${candidateId}/communicationAlerts`,
      method: 'GET',
    });
  }

  async updateCommunicationAlerts(
    candidateId: Candidate['id'],
    body: CandidateCommunicationAlerts
  ) {
    return super.write<{ data: null }>({
      endpoint: `/candidates/${candidateId}/communicationAlerts`,
      body,
      method: 'PUT',
    });
  }

  async refreshCommunicationAlerts(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/communicationAlerts`);
  }
}

export const CandidateCommunicationAlertsApi =
  new CandidateCommunicationAlertsApiClass();
